import type { ISSUE_TYPE } from '@app/shared/components/chat/chat.component';

export enum CONTENT_MIME_TYPE {
    TEXT = 'text/plain',
    MARKDOWN = 'text/markdown',
}

export enum FEEDBACK_TYPE {
    LIKE = 1,
    DISLIKE = -1,
    // biome-ignore lint/style/useLiteralEnumMembers: NULL is a valid value in this enum
    NONE = null,
}

export enum CHAT_ROLE {
    ASSISTANT = 'assistant',
    SYSTEM = 'system',
    USER = 'user',
    TOOL = 'tool',
    EVENT = 'event',
    INTERNAL = '_internal',
}

export interface ChatAttachments {
    id: number; // The attachment ID
    name: string; // The filename given by the user
    type: string; // The mimetype of the attachment
    url: string; // The URL which can be used to download the file
}

// OpenAI Completions compatible content:
export type OpenAICompletionContent = (
    | { type: 'text'; text: string }
    | { type: 'image_file'; image_file: { file_id: number } }
    | { type: 'image_url'; image_url: { url: string } }
    | { type: 'file'; file_data: string; file_name: string }
    | { type: 'file'; file: { file_id: number } }
)[];

// NOTE: In InteractionContent, We should start supporting the remaining content types: Messages, Responses, etc.
export type InteractionContent = OpenAICompletionContent;

export interface InteractionAdapter {
    id: number;
    name?: string;
    nameTooltip?: string;
    contentType?: CONTENT_MIME_TYPE;
    rating: FEEDBACK_TYPE;
    feedbackHistory?: {
        createdBy: string;
        createdDate: string;
        // Typically, either rating+message OR issueType+comment should be present. Not both.
        rating?: FEEDBACK_TYPE;
        message?: string; // A user friendly message for the `rating` change
        issueType?: ISSUE_TYPE;
        comment?: string;
    }[];
    timeTaken?: number;
    issueType?: string;
    comment?: string; // Temporary field until we have a better UX for commenting
    sortOrder?: number;
    context?: string;
    executionLogs?: string;
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    errorMessage?: string;
    isAiGenerated?: boolean;
    debugTags?: string[];
    buttons?: { label: string; userMessage: string; tooltip?: string }[];

    // OpenAI message format:
    role?: CHAT_ROLE;
    content?: InteractionContent;
    tool_calls?: {
        id: string;
        function: {
            name: string;
            arguments: string;
        };
        type: string;
    }[];
    tool_call_id?: string;
}
